import { render, staticRenderFns } from "./RedazioneList.vue?vue&type=template&id=189ffb87&"
import script from "./RedazioneList.vue?vue&type=script&lang=js&"
export * from "./RedazioneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports